import qs from 'query-string'

const DEFAULT_PATHS = {
  home: '/',
  category: {
    root: '/category',
    view: (slug: string | number) => `/category/${slug}`
  },
  customer: {
    address: {
      root: '/address',
      view: (id: string | number) => `/address/${id}`,
      create: '/customer/address/create',
    }
  },
  store: {
    root: '/stores',
    selectStore: (params: {
      page?: string;
      redirect_to?: string;
      lng?: number | string;
      lat?: number | string;
      withDistance?: boolean
    }) => {
      const { page, redirect_to, lng, lat, withDistance } = params || {};
      const queryParams = {
        page,
        redirect_to: redirect_to ?? '/',
        lng,
        lat,
        withDistance,
      }

      const queryString = qs.stringify(queryParams, {
        skipEmptyString: true,
        skipNull: true,
      })

      return `/stores/select-store?${queryString}`;
    },
    view: (id: string | number) => `/stores/${id}`,
    nearby: '/stores/nearby',
  },
  loyalty: {
    reward: {
      root: '/loyalty/reward',
    },
    membership: {
      root: '/loyalty/membership-privileges',
    },
    vouchers: {
      root: '/loyalty/vouchers',
      view: (id: string | number) => `/loyalty/vouchers/${id}`,
    }
  }
} as const

export default Object.freeze({
  paths: {
    en: DEFAULT_PATHS,
    vi: {
      ...DEFAULT_PATHS
    }
  },
  utils: {
    baseUrl: () => null,
    baseApiUrl: () => null,
    convertFullUrl: () => null,
  }
})
